(() => {
  'use strict';
  const clean = (value, length) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, length);
  const context = document.querySelector('[data-nv-enquiry-context]');
  const main = document.querySelector('main');
  if (context && main) {
    let variants = [];
    const source = main.querySelector('#nv-product-json, [data-bed-product]');
    try { variants = JSON.parse(source?.textContent || '{}').variants || []; } catch {}
    const updateLinks = () => {
      const variantId = main.querySelector('#variant-id, [data-bed-variant], [name="id"]')?.value || context.dataset.variantId;
      const variant = variants.find(item => String(item.id) === String(variantId));
      const options = variant?.title || context.dataset.variantTitle;
      const productPath = new URL(context.dataset.productPath, location.origin);
      if (/^\d+$/.test(String(variantId))) productPath.searchParams.set('variant', variantId);
      main.querySelectorAll('a[href]').forEach(link => {
        let url;
        try { url = new URL(link.getAttribute('href'), location.origin); } catch { return; }
        if (url.origin !== location.origin || !/\/pages\/contact\/?$/.test(url.pathname)) return;
        url.searchParams.set('enquiry_product', context.dataset.productTitle);
        url.searchParams.set('enquiry_url', productPath.pathname + productPath.search);
        if (options && options !== 'Default Title') url.searchParams.set('enquiry_options', options);
        else url.searchParams.delete('enquiry_options');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
    };
    updateLinks();
    document.addEventListener('nv:variant-change', updateLinks);
    main.addEventListener('change', updateLinks);
    ['pointerdown', 'focusin', 'contextmenu', 'click', 'auxclick'].forEach(name => {
      main.addEventListener(name, event => {
        if (event.target instanceof Element && event.target.closest('a[href]')) updateLinks();
      }, true);
    });
  }

  const fields = document.querySelector('[data-nv-contact-fields]');
  if (!fields) return;
  const type = document.getElementById('ContactEnquiryType');
  const product = document.getElementById('ContactProduct');
  const options = document.getElementById('ContactOptions');
  const productUrl = document.getElementById('ContactProductLink');
  const productFields = fields.querySelector('[data-nv-product-fields]');
  const productLink = fields.querySelector('[data-nv-product-link]');
  const subject = document.getElementById('ContactSubject');
  const params = new URLSearchParams(location.search);
  const incomingProduct = clean(params.get('enquiry_product'), 160);
  const incomingOptions = clean(params.get('enquiry_options'), 300);
  const incomingSubject = clean(params.get('subject'), 200);
  let canonicalProductUrl = '';
  try {
    const requestedUrl = new URL(params.get('enquiry_url') || '', location.origin);
    if (requestedUrl.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(requestedUrl.pathname)) {
      const canonical = new URL(requestedUrl.pathname, fields.dataset.storeUrl);
      const variant = requestedUrl.searchParams.get('variant');
      if (variant && /^\d+$/.test(variant)) canonical.searchParams.set('variant', variant);
      canonicalProductUrl = canonical.href;
    }
  } catch {}
  if (incomingProduct) {
    type.value = 'Product enquiry';
    if (!product.value) product.value = incomingProduct;
    if (!options.value) options.value = incomingOptions;
  }
  if (incomingSubject) {
    subject.value = incomingSubject;
    subject.disabled = false;
    fields.querySelector('[data-nv-subject-field]').hidden = false;
  }
  const updateForm = () => {
    const isProduct = type.value === 'Product enquiry';
    productFields.hidden = !isProduct;
    product.required = isProduct;
    product.disabled = !isProduct;
    options.disabled = !isProduct;
    productUrl.value = isProduct && product.value === incomingProduct ? canonicalProductUrl : '';
    productUrl.disabled = !productUrl.value;
    productLink.parentElement.hidden = !productUrl.value;
    if (productUrl.value) productLink.href = productUrl.value;
    else productLink.removeAttribute('href');
  };
  type.addEventListener('change', updateForm);
  product.addEventListener('input', () => {
    canonicalProductUrl = '';
    options.value = '';
    updateForm();
  });
  options.addEventListener('input', () => {
    if (canonicalProductUrl) {
      const url = new URL(canonicalProductUrl);
      url.searchParams.delete('variant');
      canonicalProductUrl = url.href;
    }
    updateForm();
  });
  type.form.addEventListener('submit', event => {
    product.value = clean(product.value, 160);
    options.value = clean(options.value, 300);
    updateForm();
    if (!type.form.checkValidity()) {
      event.preventDefault();
      type.form.reportValidity();
    }
  });
  window.addEventListener('pageshow', updateForm);
  updateForm();
})();
